
export default {
  props: {
    error: Object,
  },
}
